import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { RocketProvider } from '@rocket/ui';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import 'bootstrap-css-only/css/bootstrap-grid.min.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import './index.css';
import { BB_THEME } from './styles/bbTheme';
import { initColorMode } from './styles/colorMode';
import { cspNonce } from './utils/cspNonce';

// Apply the persisted/OS color mode before first paint.
initColorMode();

// AG Grid setup moved to components/AGTable/ag-grid-setup.js
// It runs lazily when the first grid component renders.

// Emotion cache with CSP nonce — every runtime <style> tag
// injected by MUI/Emotion will carry nonce="..."
// prepend:true replicates StyledEngineProvider injectFirst behaviour
// (Emotion styles inserted first so JSS can override them).
const emotionCache = createCache({ key: 'css', nonce: cspNonce, prepend: true });

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

// biome-ignore lint/style/noNonNullAssertion: #root always exists in index.html
ReactDOM.createRoot(document.getElementById('root')!).render(
  <CacheProvider value={emotionCache}>
    <QueryClientProvider client={queryClient}>
      {/* BB_THEME = rocket's legacy-root config (rem tokens scaled for the 62.5% html font-size;
          Chakra's global reset would restyle the MUI pages) + the BlackBoiler brand fragment
          (recipes/semanticTokens) that replaces MaterialTheme's `overrides`.
          toast={false}: App already renders its own ToastContainer. */}
      <RocketProvider theme={BB_THEME} toast={false} nonce={cspNonce}>
        <App />
      </RocketProvider>
    </QueryClientProvider>
  </CacheProvider>
);
